import { Header } from "../../components/Header";
import ArrowDoubleSide from "../../components/icons/ArrowDoubleSide";
import Logo from "../../components/icons/Logo";
import "./index.scss";
const AboutUs = () => {
    return (
      <div className="page splash aboutUsPage">
        <div className="background" />
        <Header />
        <div className="logo">
            <Logo />
        </div>
        <div className="triple-text">
            <span>Food Service{'\n'}</span>
            <span>Software Technology{'\n'}</span>
            <span>for Active Adult Communities</span>
        </div>
        <div className="bottom-bar">
          <span>
            Agilysys offers the broadest portfolio of Active Adult{'\n'}
            Community solutions with the deepest functionality in the{'\n'}
            market, delighting residents and empowering staff to{'\n'}
            provide exceptional service at every touchpoint.
          </span>
        </div>
        <img className="bubbles" src="https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/aboutAgilysysCommunityBubbles2.png"/>
      </div>
    );
}
export default AboutUs;